import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RowFileUploadComponent } from './row-file-upload.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    RowFileUploadComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule.forChild()
  ],
  exports: [
    RowFileUploadComponent
  ]
})
export class RowFileUploadModule { }
